import { TOGGLE_DRIVE_LINK_DRAWER } from "@/redux/types";

export const toggleDriveLinkDrawer = (open) => ({
    payload: { open },
    type: TOGGLE_DRIVE_LINK_DRAWER,
});
